/**
 * @generated SignedSource<<ff5f0f34d39c9b4bf97e1310a1a69e1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type CommentAuthorAssociation = "COLLABORATOR" | "CONTRIBUTOR" | "FIRST_TIMER" | "FIRST_TIME_CONTRIBUTOR" | "MANNEQUIN" | "MEMBER" | "NONE" | "OWNER" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueBodyHeaderSecondaryFragment$data = {
  readonly authorAssociation: CommentAuthorAssociation;
  readonly showSpammyBadge: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"MarkdownEditHistoryViewer_comment" | "MarkdownLastEditedBy">;
  readonly " $fragmentType": "IssueBodyHeaderSecondaryFragment";
};
export type IssueBodyHeaderSecondaryFragment$key = {
  readonly " $data"?: IssueBodyHeaderSecondaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyHeaderSecondaryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodyHeaderSecondaryFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MarkdownEditHistoryViewer_comment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MarkdownLastEditedBy"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showSpammyBadge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "authorAssociation",
      "storageKey": null
    }
  ],
  "type": "Comment",
  "abstractKey": "__isComment"
};

(node as any).hash = "441bf841f65ea116644822576434f48f";

export default node;
